export default __webpack_public_path__ + "static/media/addon7.edd078e0.webp";